export default __webpack_public_path__ + "static/media/Comp 2_00016.c55cf2a6.png";